import { css } from 'lit';
export const PICFontsCSS = css `
            /* quicksand-regular - latin-ext_latin */
@font-face {
    font-family: 'Quicksand';
    font-style: normal;
    font-weight: 400;
    src: url('/scripts/fonts/quicksand-v30-latin-ext_latin-regular.eot'); /* IE9 Compat Modes */
    src: local(''),
         url('/scripts/fonts/quicksand-v30-latin-ext_latin-regular.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
         url('/scripts/fonts/quicksand-v30-latin-ext_latin-regular.woff2') format('woff2'), /* Super Modern Browsers */
         url('/scripts/fonts/quicksand-v30-latin-ext_latin-regular.woff') format('woff'), /* Modern Browsers */
         url('/scripts/fonts/quicksand-v30-latin-ext_latin-regular.ttf') format('truetype'), /* Safari, Android, iOS */
         url('/scripts/fonts/quicksand-v30-latin-ext_latin-regular.svg#Quicksand') format('svg'); /* Legacy iOS */
  }

/* inter-regular - latin-ext_latin */
@font-face {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    src: url('/scripts/fonts/inter-v12-latin-ext_latin-regular.eot'); /* IE9 Compat Modes */
    src: local(''),
         url('/scripts/fonts/inter-v12-latin-ext_latin-regular.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
         url('/scripts/fonts/inter-v12-latin-ext_latin-regular.woff2') format('woff2'), /* Super Modern Browsers */
         url('/scripts/fonts/inter-v12-latin-ext_latin-regular.woff') format('woff'), /* Modern Browsers */
         url('/scripts/fonts/inter-v12-latin-ext_latin-regular.ttf') format('truetype'), /* Safari, Android, iOS */
         url('/scripts/fonts/inter-v12-latin-ext_latin-regular.svg#Inter') format('svg'); /* Legacy iOS */
  }
  
  /* montserrat-regular - latin-ext_latin */
@font-face {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 400;
    src: url('/scripts/fonts/montserrat-v25-latin-ext_latin-regular.eot'); /* IE9 Compat Modes */
    src: local(''),
    url('/scripts/fonts/montserrat-v25-latin-ext_latin-regular.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
    url('/scripts/fonts/montserrat-v25-latin-ext_latin-regular.woff2') format('woff2'), /* Super Modern Browsers */
    url('/scripts/fonts/montserrat-v25-latin-ext_latin-regular.woff') format('woff'), /* Modern Browsers */
    url('/scripts/fonts/montserrat-v25-latin-ext_latin-regular.ttf') format('truetype'), /* Safari, Android, iOS */
    url('/scripts/fonts/montserrat-v25-latin-ext_latin-regular.svg#Montserrat') format('svg'); /* Legacy iOS */
}

/* noto-sans-mono-regular - latin-ext_latin */
@font-face {
    font-family: 'Noto Sans Mono';
    font-style: normal;
    font-weight: 400;
    src: url('/scripts/fonts/noto-sans-mono-v21-latin-ext_latin-regular.eot'); /* IE9 Compat Modes */
    src: local(''),
         url('/scripts/fonts/noto-sans-mono-v21-latin-ext_latin-regular.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
         url('/scripts/fonts/noto-sans-mono-v21-latin-ext_latin-regular.woff2') format('woff2'), /* Super Modern Browsers */
         url('/scripts/fonts/noto-sans-mono-v21-latin-ext_latin-regular.woff') format('woff'), /* Modern Browsers */
         url('/scripts/fonts/noto-sans-mono-v21-latin-ext_latin-regular.ttf') format('truetype'), /* Safari, Android, iOS */
         url('/scripts/fonts/noto-sans-mono-v21-latin-ext_latin-regular.svg#NotoSansMono') format('svg'); /* Legacy iOS */
  }  

/* azeret-mono-regular - latin-ext_latin */
@font-face {
    font-family: 'Azeret Mono';
    font-style: normal;
    font-weight: 400;
    src: url('/scripts/fonts/azeret-mono-v11-latin-ext_latin-regular.eot'); /* IE9 Compat Modes */
    src: local(''),
         url('/scripts/fonts/azeret-mono-v11-latin-ext_latin-regular.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
         url('/scripts/fonts/azeret-mono-v11-latin-ext_latin-regular.woff2') format('woff2'), /* Super Modern Browsers */
         url('/scripts/fonts/azeret-mono-v11-latin-ext_latin-regular.woff') format('woff'), /* Modern Browsers */
         url('/scripts/fonts/azeret-mono-v11-latin-ext_latin-regular.ttf') format('truetype'), /* Safari, Android, iOS */
         url('/scripts/fonts/azeret-mono-v11-latin-ext_latin-regular.svg#AzeretMono') format('svg'); /* Legacy iOS */
  }

/* MaterialDesignIcons */
@font-face {
    font-family: "Material Design Icons";
    src: url("/scripts/fonts/materialdesign/fonts/materialdesignicons-webfont.eot?v=6.5.95");
    src: url("/scripts/fonts/materialdesign/fonts/materialdesignicons-webfont.eot?#iefix&v=6.5.95") format("embedded-opentype"),
         url("/scripts/fonts/materialdesign/fonts/materialdesignicons-webfont.ttf?v=6.5.95") format("truetype");
    font-weight: normal;
    font-style: normal;
  }
  
  .material-icons {
    font-family: 'Material Icons';
    font-weight: normal;
    font-style: normal;
    font-size: 24px;
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    display: inline-block;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    -webkit-font-smoothing: antialiased;
  }
        
  /* fonts */
/* fonts */
.pic-h1 {
  font-family: 'Quicksand';
  font-style: normal;
  font-weight: 300;
  font-size: 96px;
  line-height: 112px;
  letter-spacing: -1.5px;
  color: var(--pic-onSurfaceHighColor);
}
.pic-h2 {
  font-family: 'Quicksand';
  font-style: normal;
  font-weight: 300;
  font-size: 60px;
  line-height: 72px;
  letter-spacing: -0.5px;
  color: var(--pic-onSurfaceHighColor);
}
.pic-h3 {
  font-family: 'Quicksand';
  font-style: normal;
  font-weight: 400;
  font-size: 48px;
  line-height: 56px;
  color: var(--pic-onSurfaceHighColor);
}
.pic-h4 {
  font-family: 'Quicksand';
  font-style: normal;
  font-weight: 400;
  font-size: 34px;
  line-height: 36px;
  color: var(--pic-onSurfaceHighColor);
}
.pic-h5 {
  font-family: 'Quicksand';
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 24px;
  letter-spacing: 0.18px;
  color: var(--pic-onSurfaceHighColor);
}
.pic-h6 {
  font-family: 'Quicksand';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: var(--pic-onSurfaceHighColor);
}
.pic-subtitle1 {
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: var(--pic-onSurfaceHighColor);
}
.pic-subtitle2 {
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.1px;
  color: var(--pic-onSurfaceHighColor);
}
.pic-body1 {
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.5px;
  color: var(--pic-onSurfaceHighColor);
}
.pic-body2 {
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: var(--pic-onSurfaceHighColor);
}
.pic-button {
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 1.25px;
  text-transform: uppercase;
  color: var(--pic-onSurfaceHighColor);
}
.pic-caption {
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: var(--pic-onSurfaceHighColor);
}
.pic-overline {
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: var(--pic-onSurfaceHighColor);
}
.pic-body1-mono {
  font-family: 'Azeret Mono';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  text-align: right;
  color: var(--pic-onSurfaceHighColor);
}
.pic-body2-mono {
  font-family: 'Azeret Mono';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  text-align: right;
  color: var(--pic-onSurfaceHighColor);
}
.no-select {
    -webkit-touch-callout: none; /* iOS Safari */
      -webkit-user-select: none; /* Safari */
       -khtml-user-select: none; /* Konqueror HTML */
         -moz-user-select: none; /* Old versions of Firefox */
          -ms-user-select: none; /* Internet Explorer/Edge */
              user-select: none;
}
.pic-tableHeader {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.25px;
    color: var(--pic-tableHeaderColor);
}
`;
//# sourceMappingURL=PICFontsCSS.js.map